<template>
  <div id="vocabSmallInfoCard" class="plainTheme"
       :style="styleObject">
    <lazy-background
                     :src="'https://learnandwatch.s3.eu-west-3.amazonaws.com/blur2/' + currentShow.poster_path"
                     style="width: 100%"
                     :placeholder='require("../assets/placeholder.png")' position="bottom">
      <div slot="content" class="vignettecontent">
        <div id="vignetteicon" class="flexwrap centercenter mediumShadow">
          <i class="fas" :class="icon" ></i>
        </div>
        <div class="flexwrap smallTitle" style="height: min-content; flex-direction:column">
          <span style="font-weight: bold" class="line-clamp clamp1">
            {{currentShow.english_title}}
          </span>
          <span class="line-clamp clamp2" v-if="!review">
            {{'S'+currentSeason.num+'E'+currentEpisodeData.num+' - '+currentEpisodeData.english_title}}
          </span>
          <span v-else>
            Révision
          </span>
        </div>
      </div>

    </lazy-background>


  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "vignette",
  props:['color', 'icon', 'review'],
  computed: {
    ...mapGetters('global', [
      'isMobile',
    ]),
    ...mapGetters('show', [
      'currentEpisodeData',
      'currentShow',
      'currentSeason',
      'currentWordsLearnt',
    ]),

    ...mapGetters('session', [
      'sessionType',
    ]),
  styleObject: function () {
      return {
        '--color': this.color
      }
  },
  }
}
</script>

<style scoped>

#vocabSmallInfoCard{
  grid-column: 1/2;
  grid-row: 1/2;
  border-radius: 2vw 0.5vw 0.5vw 2vw;
  height: 4vw;
  overflow: hidden;
  align-items: center;
  width: 100%;
}

#vignetteicon{
  border-radius: 2vw;
  height: 2vw;
  width: 2vw;
  background-color: var(--color);
  padding: 0.5vw;
  font-size: 1.5em;

}

.vignettecontent{
  background-color: hsla(var(--hue), 100%, 25%, 45%);
  height: 3vw;
  display: grid;
  grid-template-columns: 3vw 1fr;
  grid-gap: 0.5vw;
  padding: 0.5vw;
  align-items: center;
  align-content: center;
  width: calc(100% - 1vw);
}
.smallTitle{
  text-shadow: 0 0 0.3vw #00000088;
}

</style>